<template>
	<div class="progress-bar">
		<div class='message'>{{message}} {{progressPercent}}%</div>
		<div class="bar" :style="{width:progressPercent+'%'}"></div>
	</div>
</template>
<script type="text/javascript">
export default {
	name: "ProgressBar",
	props: ["progressPercent","message"]
}	
</script>
<style type="text/css" scoped>
	.progress-bar {
		height: 30px;
		color: #a58306;
		position: relative;
		background-color: white;
	}

	.progress-bar .bar {
		background-color: #ECBA00;
		width: 0%;
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		z-index: 1;
	}

	.progress-bar .message {
		position: relative;
		z-index: 2;
	}
</style>